import { Alert, Button, Snackbar } from '@mui/material';
import { ReactNode } from 'react';
import { useToast } from '@/hooks/useToast';

export const ToastProvider = ({ children }: { children: ReactNode }) => {
  const { open, message, type, action, hideToast } = useToast();

  const handleActionClick = () => {
    action?.onClick();
    hideToast();
  };

  return (
    <>
      {children}
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={hideToast}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Alert
          onClose={hideToast}
          severity={type}
          sx={{
            width: '100%',
            '& .MuiAlert-message': {
              display: 'flex',
              alignItems: 'center',
            },
            '& .MuiAlert-action': {
              paddingTop: 0,
              alignItems: 'center',
            },
          }}
          action={
            action ? (
              <Button color='inherit' size='small' onClick={handleActionClick} sx={{ fontWeight: 600 }}>
                {action.label}
              </Button>
            ) : undefined
          }
        >
          {message}
        </Alert>
      </Snackbar>
    </>
  );
};
